export const MONTHS = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December'
};

export const ALLOWED_ROLES = ['project_read_only', 'project_user'];
export const isAnyAllowedRoles = (roles = []) => roles.length > 0 && roles.some((role) => ALLOWED_ROLES.includes(role));